import { render, staticRenderFns } from "./CDetailForPublic.vue?vue&type=template&id=40a70a14&"
import script from "./CDetailForPublic.vue?vue&type=script&lang=ts&"
export * from "./CDetailForPublic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports